import { styled } from 'styled-components';

import { rem } from '@desygner/ui-common-components';

export const StyledTimestampWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => rem(theme.Spacing.XXSmall)};
`;
